import * as React from "react";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import IconButton from "@mui/material/IconButton";
import {FriendSelector} from "./FriendSelector/FriendSelector";
import Badge from "@mui/material/Badge";
import {FormModal} from "../../../../../Components/FormModal";
import {SaveButton} from "../../../../../Components/SaveButton";
import {Currency} from "../../../../../../config/currencies";
import Box from "@mui/material/Box";
import {ITransactionSplit} from "../../../../../../config/transactions";

interface IShareWithFriendsFieldProps {
    value: ITransactionSplit[];
    onChange(data: ITransactionSplit[]): void;
    amount: string;
    currency: Currency;
}

export const ShareWithFriendsField = ({value, onChange, amount, currency}: IShareWithFriendsFieldProps) => {
    const [open, setOpen] = React.useState(false);
    const [values, setValues] = React.useState(value);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const handleAdd = (data: ITransactionSplit) => {
        setValues(currentData => [...currentData, data]);
    };

    const handleChange = (index: number) => (data: ITransactionSplit | null) => {
        setValues(prev => {
            if (data === null) {
                return prev.filter((d, i) => i !== index);
            }

            const newData = prev.slice();
            newData[index] = data

            return newData;
        });
    };

    const handleSave = () => {
        onChange(values);
        handleClose();
    };

    React.useEffect(() => {
        setValues(value);
    }, [value]);

    return (
        <>
            <Box sx={{marginLeft: (theme) => theme.spacing(0.5)}}>
                <IconButton size="small" color="primary" onClick={handleOpen} disabled={amount === ''}>
                    <Badge invisible={!values.length} color="error" variant="dot" overlap="rectangular">
                        <GroupAddIcon />
                    </Badge>
                </IconButton>
            </Box>

            <FormModal loading={false} open={open} onClose={handleClose} title="Share this transaction">
                <>
                    {values.map((item, i) => (
                        <FriendSelector
                            key={i}
                            value={item}
                            onChange={handleChange(i)}
                            originalAmount={amount}
                            originalCurrency={currency}
                        />
                    ))}
                    <FriendSelector onChange={handleAdd} originalAmount={amount} originalCurrency={currency} />

                    {(!!values.length || !!value.length) &&
                        <SaveButton loading={false} onSubmit={handleSave} />
                    }
                </>
            </FormModal>
        </>
    );
};
